exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.qortex-container[data-v-b37cddfe]{display:flex;margin-bottom:30px !important;align-items:center;justify-content:space-between\n}\n.md-headline[data-v-b37cddfe]{margin:0px\n}\n.cancel-btn[data-v-b37cddfe]{background-color:#d33 !important;color:#fff !important;font-size:1.1em\n}\n.cancel-btn[data-v-b37cddfe] :hover{background-color:#d33 !important\n}\n.btn-container[data-v-b37cddfe]{display:flex;justify-content:end;margin-top:20px\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-b37cddfe","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/forms/QortexForm.vue
// module id = 161
// module chunks = 0